export default "__VITE_ASSET__CMcUv2t3__"